module.exports = __webpack_public_path__ + "img/cnhi.f5cf236f.svg";